import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faUserLock, faCog, faHistory, faInfo, faFileDownload, faBezierCurve } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, faUserLock, faCog, faHistory, faInfo, faFileDownload, faBezierCurve)

export { FontAwesomeIcon }
